import React from "react"
import {FilterCondition} from "../filterTypes"
import {formatConditionForDisplay} from "../filterUtils"

// Helper component to display filter conditions
export const FilterConditionDisplay = ({
  condition,
}: {
  condition: FilterCondition
}) => {
  // Get formatted parts for display
  const {fieldLabel, conditionLabel} = formatConditionForDisplay(condition)

  return (
    <div className="mb-3 border-b border-gray-100 pb-2 last:border-b-0">
      <div className="flex flex-col gap-1">
        {/* Field name with distinctive styling */}
        <div className="flex items-baseline">
          <span className="mr-2 font-medium text-gray-800">{fieldLabel}</span>
          <span className="text-sm font-medium text-blue-600">
            {conditionLabel}
          </span>
        </div>

        {/* Value display with appropriate styling based on type */}
        <div className="ml-2 mt-1">
          {Array.isArray(condition.value) ? (
            <div className="flex flex-col gap-1">
              {condition.value.map((val, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-1 text-sm text-gray-700"
                >
                  <span className="h-1.5 w-1.5 flex-shrink-0 rounded-full bg-gray-400"></span>
                  <span>{val}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="border-l-2 border-gray-200 pl-3 text-sm text-gray-700">
              {condition.value}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
